import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, Tabs, Tab } from 'react-bootstrap';
import { FaPlus, FaCheck, FaThumbsUp, FaTimes, FaTrash, FaEdit, FaSortAmountUp, FaSortAmountDown, FaArrowLeft, FaArrowRight, FaSearch, FaRedo, FaCog, FaHandshake, FaCogs, FaInfoCircle, FaUser, FaCalendarAlt, FaListAlt, FaMoneyBillWave, FaPercentage, FaUserCheck, FaTag, FaHistory, FaWallet, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';
import { getAuthToken } from '../../../authToken';

// Composant Portefeuille
const PortefeuillePartenaire = ({ totalGagne, pourcentage, inscriptions, userData, onRefresh }) => {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <>
            <div className="row mb-4">
                <div className="col-md-3">
                    <div className="card border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)' }}>
                        <div className="card-body text-white">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <small className="text-white-50">Total gagné</small>
                                    <h3 className="mb-0 fw-bold">{userData.gain_partenariat ? userData.gain_partenariat.toLocaleString() : 0} FCFA</h3>
                                </div>
                                <FaMoneyBillWave size={32} className="opacity-75" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <small className="text-muted">Commission</small>
                                    <h4 className="mb-0 text-success">{pourcentage || 0}%</h4>
                                </div>
                                <FaPercentage size={24} className="text-success" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <small className="text-muted">Inscriptions</small>
                                    <h4 className="mb-0 text-primary">{inscriptions.length}</h4>
                                </div>
                                <FaUserCheck size={24} className="text-primary" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <small className="text-muted">Code partenaire</small>
                                    <h6 className="mb-0 text-info" style={{ fontSize: '14px' }}>
                                        {userData?.code_partenaire || 'Non défini'}
                                    </h6>
                                </div>
                                <FaTag size={20} className="text-info" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="alert alert-info mb-4 d-flex align-items-center">
                <FaInfoCircle size={18} className="mr-2" />
                <small>
                    <strong>Comment ça fonctionne ?</strong> Les apprenants qui utilisent votre code bénéficient d'une réduction de <strong>5%</strong> sur le montant de la formation. 
                    Vu que votre pourcentage partenariat est de <strong>{userData.pourcentage_partenariat}%</strong> vous recevrez donc une commission de <strong>{userData.pourcentage_partenariat - 5 || 0}%</strong> sur le montant après réduction.
                </small>
            </div>
        </>
    );
};

const PartenairePage = ({ titre }) => {
    useAuth();

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const [partenaires, setPartenaires] = useState([]);
    const [selectedPartenaire, setSelectedPartenaire] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [totalGagne, setTotalGagne] = useState(0);
    const [historiqueTransactions, setHistoriqueTransactions] = useState([]);
    const [activeTab, setActiveTab] = useState('inscriptions');
    const [soldeData, setSoldeData] = useState({ total_entrees: 0, total_sorties: 0, solde: 0 });
    
    // Pagination for historique
    const [currentHistoPage, setCurrentHistoPage] = useState(1);
    const [itemsHistoPerPage, setItemsHistoPerPage] = useState(10);
    const [histoSearchTerm, setHistoSearchTerm] = useState('');

    const [userData, setUserData] = useState({});

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                    method: 'get',
                    headers: {
                        'content-type': 'application/json',
                        'authorization': `Bearer ${token}`
                    },
                });
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
            } catch (error) {
                console.error('Erreur lors du chargement du profil:', error);
            }
        };

        fetchUserData();
    }, [user_id]);

    // Pagination state for main table
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = partenaires.length;

    // Modal detail state
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Partenaires";
        }
    }, [user_id]);

    // Fetch historique transactions
    const fetchHistoriqueTransactions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-historique-partenaire/${user_id}/`);
            if (response.data.success) {
                setHistoriqueTransactions(response.data.transactions || []);
                setSoldeData(response.data.totaux || { total_entrees: 0, total_sorties: 0, solde: 0 });
            }
        } catch (error) {
            console.error('Error fetching historique:', error);
        }
    };

    // Fetch partenaires data depuis liste-inscriptions
    const fetchPartenaires = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');
            const userResponse = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const userInfo = await userResponse.json();

            if (userInfo.code_partenaire) {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-inscriptions/?code_partenaire=${userInfo.code_partenaire}&per_page=100`);
                if (response.ok) {
                    const data = await response.json();

                    const transformedData = data.data.map(inscription => {
                        const montantFacture = inscription.montant_facture ? parseFloat(inscription.montant_facture) : 0;
                        const discount = inscription.discount ? parseFloat(inscription.discount) : 0;
                        const gain = montantFacture * (discount / 100);

                        return {
                            id: inscription.id,
                            code_partenaire: userInfo.code_partenaire,
                            pourcentageCeder: userInfo.pourcentage_partenariat || 0,
                            date_creation: inscription.date_inscription,
                            date_expiration: null,
                            utilise_par: `${inscription.prenoms} ${inscription.nom}`,
                            date_utilisation: inscription.date_inscription,
                            inscription: {
                                ...inscription,
                                montant_facture: inscription.montant_facture,
                                discount: inscription.discount,
                                reste_a_payer: inscription.reste_a_payer,
                                solde_complet: inscription.solde_complet,
                                montant_paye: inscription.montant_paye
                            },
                            montant_gagne: gain
                        };
                    });

                    setPartenaires(transformedData);
                    const total = transformedData.reduce((sum, item) => sum + (item.montant_gagne || 0), 0);
                    setTotalGagne(total);
                }
            }
            
            await fetchHistoriqueTransactions();
            
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de chargement des données', 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPartenaires();
    }, []);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };

    const handleRowClick = (partenaire) => {
        setSelectedPartenaire(partenaire);
    };

    // Filter for main table
    const filteredPartenaires = partenaires.filter(p =>
        p.code_partenaire?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (p.utilise_par && p.utilise_par.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (p.date_creation && p.date_creation.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    // Filter for historique table
    const filteredHistorique = historiqueTransactions.filter(t =>
        t.reference?.toLowerCase().includes(histoSearchTerm.toLowerCase()) ||
        t.commentaire?.toLowerCase().includes(histoSearchTerm.toLowerCase()) ||
        t.mode?.toLowerCase().includes(histoSearchTerm.toLowerCase())
    );

    const sortedPartenaires = [...filteredPartenaires].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination for main table
    const indexOfLastPartenaire = currentPage * itemsPerPage;
    const indexOfFirstPartenaire = indexOfLastPartenaire - itemsPerPage;
    const currentPartenaires = sortedPartenaires.slice(indexOfFirstPartenaire, indexOfLastPartenaire);
    const totalPages = Math.ceil(sortedPartenaires.length / itemsPerPage);

    // Pagination for historique table
    const indexOfLastHisto = currentHistoPage * itemsHistoPerPage;
    const indexOfFirstHisto = indexOfLastHisto - itemsHistoPerPage;
    const currentHistorique = filteredHistorique.slice(indexOfFirstHisto, indexOfLastHisto);
    const totalHistoPages = Math.ceil(filteredHistorique.length / itemsHistoPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleHistoItemsPerPageChange = (e) => {
        setItemsHistoPerPage(Number(e.target.value));
        setCurrentHistoPage(1);
    };

    const handleShowDetail = async (partenaire) => {
        if (partenaire.inscription) {
            setSelectedPartenaire(partenaire);
            const inscription = partenaire.inscription;
            
            const montantFacture = inscription.montant_facture ? parseFloat(inscription.montant_facture) : 0;
            const discount = inscription.discount ? parseFloat(inscription.discount) : 0;
            const gain = montantFacture * (discount / 100);

            const utilisateurData = {
                nom: inscription.nom,
                prenoms: inscription.prenoms,
                email: inscription.email,
                tel: inscription.telephone,
                date_insc: inscription.date_inscription,
                profession: inscription.profession,
                diplome: inscription.diplome,
                type_financement: inscription.type_financement,
                entreprise: inscription.entreprise,
                ref_formation: inscription.ref_formation,
                formation: inscription.formation_info,
                montant_facture: inscription.montant_facture,
                discount: inscription.discount,
                reste_a_payer: inscription.reste_a_payer,
                solde_complet: inscription.solde_complet,
                montant_gagne: gain,
                pourcentage: discount
            };

            setDetailData(utilisateurData);
            setShowDetailModal(true);
        } else {
            showAlert("Ce code n'a pas encore été utilisé", 'info');
        }
    };

    const handleCloseDetailModal = () => setShowDetailModal(false);

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaHandshake size={25} className='mr-2' /> Partenaire
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Page-partenaire`}> Partenaires</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="justify-content-center align-items-center mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="justify-content-center align-items-center">

                            {/* Portefeuille partenaire */}
                            <PortefeuillePartenaire
                                totalGagne={totalGagne}
                                pourcentage={userData.pourcentage_partenariat}
                                inscriptions={partenaires}
                                userData={userData}
                                onRefresh={fetchPartenaires}
                            />

                            {/* Onglets avec bouton détails à droite */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <Tabs
                                    activeKey={activeTab}
                                    onSelect={(k) => setActiveTab(k)}
                                    className="mb-0 flex-grow-1"
                                >
                                    <Tab eventKey="inscriptions" title={
                                        <span><FaMoneyBillWave className="mr-1" /> Inscriptions</span>
                                    } />
                                    <Tab eventKey="historique" title={
                                        <span><FaHistory className="mr-1" /> Historique des transactions</span>
                                    } />
                                </Tabs>
                                <button
                                    onClick={() => selectedPartenaire && handleShowDetail(selectedPartenaire)}
                                    className={`btn d-flex align-items-center justify-content-center ms-2 ${selectedPartenaire ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!selectedPartenaire}
                                >
                                    <FaInfoCircle />
                                    <span className="d-none d-sm-inline ml-1">
                                        Détail
                                    </span>
                                </button>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',
                                            right: '10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}

                            {/* Panneau Inscriptions */}
                            {activeTab === 'inscriptions' && (
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-lg-12">
                                        <div className="ibox">
                                            <div className="ibox-content">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <div className="me-2">
                                                        <select
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                            className="form-select bg-default p-1"
                                                            style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={20}>20</option>
                                                            <option value={50}>50</option>
                                                        </select>
                                                    </div>
                                                    <div className="input-group" style={{ width: '300px' }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Rechercher..."
                                                            className="form-control"
                                                            value={searchTerm}
                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                    <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-secondary' onClick={() => handleSort('date_utilisation')}>
                                                                    Date {sortConfig.key === 'date_utilisation' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                </th>
                                                                <th className='text-secondary' onClick={() => handleSort('utilise_par')}>
                                                                    Utilisé par {sortConfig.key === 'utilise_par' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                </th>
                                                                <th className='text-secondary text-center' onClick={() => handleSort('montant_facture')}>
                                                                    Montant formation {sortConfig.key === 'montant_facture' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                </th>
                                                                <th className='text-secondary text-center' onClick={() => handleSort('gain')}>
                                                                    Gain {sortConfig.key === 'gain' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                </th>
                                                                <th className='text-secondary text-center' onClick={() => handleSort('solde')}>
                                                                    Soldé {sortConfig.key === 'solde' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        {!isLoading ? (
                                                            <tbody>
                                                                {currentPartenaires.length > 0 ? currentPartenaires.map((partenaire) => {
                                                                    const montantFacture = partenaire.inscription?.montant_facture
                                                                        ? parseFloat(partenaire.inscription.montant_facture)
                                                                        : 0;
                                                                    const gain = montantFacture * ((partenaire.inscription.discount || 0) / 100);
                                                                    const resteAPayer = partenaire.inscription?.reste_a_payer
                                                                        ? parseFloat(partenaire.inscription.reste_a_payer)
                                                                        : 0;
                                                                    const estSolde = resteAPayer <= 0 || partenaire.inscription?.solde_complet === true;

                                                                    return (
                                                                        <tr
                                                                            key={partenaire.id}
                                                                            className={`bg-white ${selectedPartenaire && selectedPartenaire.id === partenaire.id ? 'bg-success text-white' : ''}`}
                                                                            onClick={() => handleRowClick(partenaire)}
                                                                        >
                                                                            <td>{partenaire.date_utilisation ? new Date(partenaire.date_utilisation).toLocaleDateString() : '-'}</td>
                                                                            <td>{partenaire.utilise_par || 'Non utilisé'}</td>
                                                                            <td className="text-center">{montantFacture.toLocaleString()} FCFA</td>
                                                                            <td className="text-center">{Math.round(gain).toLocaleString()} FCFA</td>
                                                                            <td className="text-center">
                                                                                {estSolde ? (
                                                                                    <FaCheck className="text-success" size={18} title="Payé" />
                                                                                ) : (
                                                                                    <FaTimes className="text-danger" size={18} title="Non soldé" />
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }) : (
                                                                    <tr>
                                                                        <td colSpan="5" className="text-center">Aucune inscription trouvée</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        ) : (
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan="5" className="text-center p-5">
                                                                        <div className="d-flex justify-content-center align-items-center">
                                                                            <div className="spiner-example">
                                                                                <div className="sk-spinner sk-spinner-wave">
                                                                                    <div className="sk-rect1 mr-1"></div>
                                                                                    <div className="sk-rect2 mr-1"></div>
                                                                                    <div className="sk-rect3 mr-1"></div>
                                                                                    <div className="sk-rect4 mr-1"></div>
                                                                                    <div className="sk-rect5"></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        )}
                                                    </table>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div className="dataTables_info" role="status" aria-live="polite">
                                                        {totalItems === 0
                                                            ? "Aucun élément à afficher"
                                                            : `Élément ${indexOfFirstPartenaire + 1} à ${Math.min(indexOfLastPartenaire, totalItems)} sur ${totalItems}`}
                                                    </div>
                                                    <div>
                                                        <button
                                                            onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                            className="btn btn-light mx-1"
                                                            disabled={currentPage === 1}
                                                        >
                                                            <FaArrowLeft />
                                                        </button>

                                                        {(() => {
                                                            const pagesToShow = 5;
                                                            let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                            let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                            if (endPage - startPage < pagesToShow - 1) {
                                                                startPage = Math.max(1, endPage - pagesToShow + 1);
                                                            }

                                                            const pageButtons = [];

                                                            for (let i = startPage; i <= endPage; i++) {
                                                                pageButtons.push(
                                                                    <button
                                                                        key={i}
                                                                        onClick={() => setCurrentPage(i)}
                                                                        className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                    >
                                                                        {i}
                                                                    </button>
                                                                );
                                                            }

                                                            return pageButtons;
                                                        })()}

                                                        <button
                                                            onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                            className="btn btn-light mx-1"
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <FaArrowRight />
                                                        </button>

                                                        <button
                                                            onClick={() => setCurrentPage(totalPages)}
                                                            className="btn btn-light mx-1"
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            {totalPages}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Panneau Historique */}
                            {activeTab === 'historique' && (
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-lg-12">
                                        <div className="ibox">
                                            <div className="ibox-content">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <div className="me-2">
                                                        <select
                                                            value={itemsHistoPerPage}
                                                            onChange={handleHistoItemsPerPageChange}
                                                            className="form-select bg-default p-1"
                                                            style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={20}>20</option>
                                                            <option value={50}>50</option>
                                                        </select>
                                                    </div>
                                                    <div className="input-group" style={{ width: '300px' }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Rechercher une transaction..."
                                                            className="form-control"
                                                            value={histoSearchTerm}
                                                            onChange={(e) => setHistoSearchTerm(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                    <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Type</th>
                                                                <th>Montant</th>
                                                                <th>Mode</th>
                                                                <th>Référence</th>
                                                                <th>Commentaire</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {currentHistorique.length > 0 ? (
                                                                currentHistorique.map((transaction) => (
                                                                    <tr key={transaction.id}>
                                                                        <td>{new Date(transaction.date).toLocaleDateString()}</td>
                                                                        <td>
                                                                            {transaction.type === 'ENTREE' ? (
                                                                                <span className="badge bg-success">
                                                                                    <FaArrowUp className="mr-1" /> Entrée
                                                                                </span>
                                                                            ) : (
                                                                                <span className="badge bg-danger">
                                                                                    <FaArrowDown className="mr-1" /> Sortie
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td className={`fw-bold ${transaction.type === 'ENTREE' ? 'text-success' : 'text-danger'}`}>
                                                                            {transaction.type === 'ENTREE' ? '+' : '-'} {transaction.montant.toLocaleString()} FCFA
                                                                        </td>
                                                                        <td>{transaction.mode}</td>
                                                                        <td><code>{transaction.reference}</code></td>
                                                                        <td>{transaction.commentaire}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="6" className="text-center text-muted">
                                                                        Aucune transaction trouvée
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div className="dataTables_info" role="status" aria-live="polite">
                                                        {filteredHistorique.length === 0
                                                            ? "Aucun élément à afficher"
                                                            : `Élément ${indexOfFirstHisto + 1} à ${Math.min(indexOfLastHisto, filteredHistorique.length)} sur ${filteredHistorique.length}`}
                                                    </div>
                                                    <div>
                                                        <button
                                                            onClick={() => setCurrentHistoPage(currentHistoPage > 1 ? currentHistoPage - 1 : 1)}
                                                            className="btn btn-light mx-1"
                                                            disabled={currentHistoPage === 1}
                                                        >
                                                            <FaArrowLeft />
                                                        </button>

                                                        {(() => {
                                                            const pagesToShow = 5;
                                                            let startPage = Math.max(1, currentHistoPage - Math.floor(pagesToShow / 2));
                                                            let endPage = Math.min(totalHistoPages, startPage + pagesToShow - 1);

                                                            if (endPage - startPage < pagesToShow - 1) {
                                                                startPage = Math.max(1, endPage - pagesToShow + 1);
                                                            }

                                                            const pageButtons = [];

                                                            for (let i = startPage; i <= endPage; i++) {
                                                                pageButtons.push(
                                                                    <button
                                                                        key={i}
                                                                        onClick={() => setCurrentHistoPage(i)}
                                                                        className={`btn ${currentHistoPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                    >
                                                                        {i}
                                                                    </button>
                                                                );
                                                            }

                                                            return pageButtons;
                                                        })()}

                                                        <button
                                                            onClick={() => setCurrentHistoPage(currentHistoPage < totalHistoPages ? currentHistoPage + 1 : totalHistoPages)}
                                                            className="btn btn-light mx-1"
                                                            disabled={currentHistoPage === totalHistoPages}
                                                        >
                                                            <FaArrowRight />
                                                        </button>

                                                        <button
                                                            onClick={() => setCurrentHistoPage(totalHistoPages)}
                                                            className="btn btn-light mx-1"
                                                            disabled={currentHistoPage === totalHistoPages}
                                                        >
                                                            {totalHistoPages}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Detail Modal */}
            <Modal show={showDetailModal} onHide={handleCloseDetailModal} size="lg">
                <Modal.Header>
                    <Modal.Title className="d-flex align-items-center">
                        <FaInfoCircle className="mr-2" />
                        Détails de l'inscription
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {detailData ? (
                        <div className="row">
                            <div className="col-md-6">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 d-flex align-items-center">
                                            <FaUser className="mr-2" />
                                            Informations personnelles
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Nom complet :</div>
                                            <div className="col-7">{detailData.prenoms} {detailData.nom}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Email :</div>
                                            <div className="col-7">{detailData.email}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Téléphone :</div>
                                            <div className="col-7">{detailData.tel}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Date inscription :</div>
                                            <div className="col-7">{detailData.date_insc ? new Date(detailData.date_insc).toLocaleDateString() : 'Non disponible'}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Profession :</div>
                                            <div className="col-7">{detailData.profession || 'Non renseigné'}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Diplôme :</div>
                                            <div className="col-7">{detailData.diplome || 'Non renseigné'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 d-flex align-items-center">
                                            <FaMoneyBillWave className="mr-2" />
                                            Informations financières
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Formation :</div>
                                            <div className="col-7">{detailData.formation?.nom || detailData.ref_formation || 'Non spécifiée'}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Montant :</div>
                                            <div className="col-7 fw-bold text-primary">{detailData.montant_facture ? parseFloat(detailData.montant_facture).toLocaleString() : 0} FCFA</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Commission :</div>
                                            <div className="col-7">{detailData.discount || 0}%</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Reste à payer :</div>
                                            <div className="col-7">{detailData.reste_a_payer ? parseFloat(detailData.reste_a_payer).toLocaleString() : 0} FCFA</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Statut :</div>
                                            <div className="col-7">
                                                {detailData.solde_complet ? (
                                                    <span className="text-success fw-bold">Soldé</span>
                                                ) : (
                                                    <span className="text-warning fw-bold">Non soldé</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 fw-bold">Votre gain :</div>
                                            <div className="col-7 fw-bold text-success">{detailData.montant_gagne?.toLocaleString() || 0} FCFA</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <div className="alert alert-info">
                                Aucune information disponible
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDetailModal}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default PartenairePage;